import React from 'react';
import { motion } from 'framer-motion';
import { clientLogos } from '../data/home';
export function TrustBuilder() {
  return <section className="bg-stark-white border-y border-midnight-navy/10 py-12" data-id="element-214" data-mp="pe2b90wzlz97">
      <div className="max-w-7xl mx-auto px-6 space-y-8" data-id="element-215" data-mp="u5twcvxdjcry">
        <p className="text-center text-midnight-navy/40 text-xs font-bold uppercase tracking-[0.2em]" data-id="element-216" data-mp="u8g3iugcrq9n">
          Trusted by Growing Businesses
        </p>
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-x-8 gap-y-6" data-id="element-217" data-mp="1ipuv0xhpgkx">
          {clientLogos.map((name, idx) => <motion.div key={name} initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: idx * 0.05
        }} className="flex items-center justify-center text-center" data-id="element-218" data-mp="6ica1fwvp6wd" data-mpi={idx}>
              <span className="text-midnight-navy/50 hover:text-midnight-navy font-montserrat font-bold text-sm tracking-tight transition-colors" data-id="element-219" data-mp="3g14eta7nh4cs">
                {name}
              </span>
            </motion.div>)}
        </div>
      </div>
    </section>;
}